import { jsx as _jsx } from "react/jsx-runtime";
import { DynamicCard } from "./DynamicCard";
import { ProfileTourCard } from "./ProfileTourCard";
// Note: chart rendering is NOT handled here. Charts flow via
// message.renders → web/src/rendering/Renderer.tsx. This registry only
// dispatches input-oriented interactive cards (tour steps, LLM-built forms).
const CARD_REGISTRY = {
    profile_tour_step: ProfileTourCard,
    llm_card: DynamicCard,
};
export function InteractiveCardHost({ card, onSubmit, onSkip }) {
    const Component = CARD_REGISTRY[card.card_type];
    if (!Component)
        return null;
    return _jsx(Component, { card: card, onSubmit: onSubmit, onSkip: onSkip });
}
